import { FC, useMemo } from 'react'
import { useRouter } from 'next/router'
import useAuthorization from '@/hooks/useAuthorization'
import { LeftNavigation, NavigationItem } from '@saasalerts/ui'
import {
  faTable,
  faFileLines,
  faClock,
  faCog,
} from '@awesome.me/kit-e270131d0a/icons/classic/regular'

export const Nav: FC<React.PropsWithChildren<unknown>> = () => {
  const router = useRouter()
  const { isAllowed } = useAuthorization()

  const items = useMemo<NavigationItem[]>(() => {
    const base: NavigationItem[] = [
      // Section header
      { title: 'General', isSectionHeader: true },
      // Top-level items
      { title: 'Risk Dashboard', href: '/', icon: faTable },
      { title: 'Reports', href: '/reports', icon: faFileLines },
      { title: 'Scheduled Reports', href: '/scheduled-reports', icon: faClock },
      { title: 'Settings', href: '/settings', icon: faCog },
    ]

    return base
      .filter(
        (item) =>
          item.isSectionHeader || (item.href ? isAllowed(item.href) : true)
      )
      .map((item) => {
        if (item.isSectionHeader) {
          return { title: item.title, isSectionHeader: true }
        }
        const isActive =
          item.href === '/'
            ? router.pathname === '/'
            : router.pathname.startsWith(item.href as string)
        return {
          title: item.title,
          href: item.href,
          icon: item.icon,
          isActive,
          onClick: () => {
            if (!item.href) return
            router.push(item.href)
          },
        }
      })
  }, [router.pathname, isAllowed, router])

  return (
    <LeftNavigation
      items={items}
      variant="white"
      className="z-10 print:!hidden"
    />
  )
}
